module.exports = __webpack_public_path__ + "img/lera-work-3.368d9fe5.webp";